import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../services/config';
import { ShipmentTransportOrderEndpoint } from '../../constants';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { ShipmentTransportOrderMapData } from '../../models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShipmentTransportOrderTrackingMapService {
  constructor(private http: WrapperHttpService) {}

  getShipmentTransportOrderTrackingMapData(transportOrderNumber: number): Observable<ShipmentTransportOrderMapData> {
    return this.http
      .withLoading()
      .get<ShipmentTransportOrderMapData>(
        `${API_URL}${ShipmentTransportOrderEndpoint.Base}${ShipmentTransportOrderEndpoint.Tos}${
          ShipmentTransportOrderEndpoint.Map
        }?${getQueryStringFromObject({ transportOrderNumber })}`,
      );
  }
}
